var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractNotPaid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_833_882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0.833984C11.0874 0.833984 12.004 1.53343 12.3457 2.5H15.833C16.7538 2.5 17.5 3.24616 17.5 4.16699V15.833C17.5 16.7538 16.7538 17.5 15.833 17.5H4.16699C3.24616 17.5 2.5 16.7538 2.5 15.833V4.16699C2.5 3.24616 3.24616 2.5 4.16699 2.5H7.6543C7.99602 1.53343 8.91257 0.833984 10 0.833984ZM10 9.85742L7.14258 7L6 8.14258L8.85742 11L6.00195 13.8555L7.14453 14.998L10 12.1426L12.8555 14.998L13.998 13.8555L11.1426 11L14 8.14258L12.8574 7L10 9.85742ZM10 2.5C9.54183 2.5 9.16726 2.87074 9.16699 3.33301C9.16699 3.79551 9.54167 4.16699 10 4.16699C10.4583 4.16699 10.833 3.79551 10.833 3.33301C10.8327 2.87074 10.4582 2.5 10 2.5Z",
    fill: "#14AC63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_833_882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractNotPaid);
export default __webpack_public_path__ + "static/media/ContractNotPaid.c8126d92a16f58cefcd9131f5f5a7eb2.svg";
export { ForwardRef as ReactComponent };